<template>
	<div class="container">
		<el-row :gutter="5">
			<el-col :span="24">
				<el-menu mode="horizontal" :defaultActive="activeIndex" class="top-nav-menu" background-color="#fff"
					text-color="#333" activeTextColor="#009933" @select='onMenuSelect'>
					<el-menu-item v-for="(item,index) in categoryList" :key="index" :index="String(index)">
						{{item.name}}
					</el-menu-item>
				</el-menu>
			</el-col>

			<el-col :span="24" style="padding-top: 10px;padding-bottom: 10px;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">
						<i class="el-icon-house">首页</i>
					</el-breadcrumb-item>
					<el-breadcrumb-item>{{activeName}}</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>

			<el-col :span="24" class="cls_form">
				<el-form ref="form" :model="searchForm" label-width="80px" size="mini">
					<el-form-item label="分类标签:">
						<el-link :underline="false" type="success">
							<el-tag v-for="item in items" style="margin-right: 10px;" size="small" :key="item.name"
								type="success" :effect="item.selected?'dark':'plain'" @click="onTagsClicked(item)">
								{{ item.name }}
							</el-tag>
						</el-link>
					</el-form-item>
				</el-form>
			</el-col>

			<el-col :span="18" style="margin-top: 5px;">
				<el-row :gutter="10" v-for="(item,index) in infoList" :key="index" class="msg_item">
					<el-col :span="3">
						<el-image :src="item.cmsHeader" fit="cover" alt="轮播图" class="item-img" />
					</el-col>
					<el-col :span="16" style="display: flex; flex-direction: column; height: 120px;">
						<div style="flex: 1;">
							<h2 style="margin: 0 0 8px 0; font-size: 16px; text-align: start;">{{ item.title }}</h2>
							<div style="font-size: 13px; color: #999; line-height: 1.4;">{{ item.content }}</div>
						</div>

						<div style="display: flex; flex-direction: row; margin-bottom: 10px;">
							<el-tag style="margin-right: 10px;" size="small" type="info" effect="dark">
								{{ item.categoryName }}
							</el-tag>
						</div>
					</el-col>


					<el-col :span="5" style="display: flex; flex-direction: column; height: 120px;">
						<div style="flex:1;">
							{{ item.publishTime }}
						</div>

						<div style="display: flex; flex-direction: row; margin-bottom: 10px;text-align: center;"
							@click="ViewDetail(item)">
							<el-button type="success" size="mini" round>
								查看详情
							</el-button>
						</div>
					</el-col>
				</el-row>
			</el-col>

			<el-col :span="6" style="margin-top: 5px; padding-left: 5px;">
				<div v-for="(item,index) in bannerList" :key="index" style="margin-bottom: 2px;">
					<el-image :src="item.imgUrl" fit="contain" alt="轮播图" class="item-img-ad" />
				</div>
			</el-col>
		</el-row>

	</div>
</template>

<script>
	import {
		getCategories,
		getBannerList
	} from '@/api/category.js'

	import {
		getInfoList
	} from '@/api/info.js'


	export default {
		name: 'Category',
		data() {
			return {
				currentCategoryId: null,
				activeIndex: '1',
				activeName: '',
				searchForm: {},
				categoryList: [],
				infoList: [],
				items: [],
				bannerList: []
			}
		},


		mounted() {
			this.getCategories()
			this.loadADBanner()
		},



		methods: {




			async loadADBanner() {
				const bannerResult = await getBannerList()
				if (bannerResult.code == 200) {
					this.bannerList = []
					this.bannerList = bannerResult.data
				}
			},


			/**
			 * @param {Object} item
			 * 菜单激活
			 */
			async onMenuSelect(item) {
				if (item == 0) {
					this.$router.push({
						path: '/'
					});
				} else {
					const temp = this.categoryList[item]
					const categoryId = temp.id
					this.activeName = temp.name
					this.getCMSListByCategoryId(categoryId)
				}
			},




			/**
			 * 下载分类信息的列表
			 */
			async getCategories() {
				const temResult = await getCategories(0)
				if (temResult.code == 200) {
					this.categoryList = []
					this.categoryList = temResult.data
					this.categoryList.unshift({
						id: 0,
						name: '首页'
					})
					const categoryId = this.$route.query.categoryId
					for (let i = 0; i < this.categoryList.length; i++) {
						const temp = this.categoryList[i]
						if (temp.id == categoryId) {
							this.activeIndex = String(i)
							this.activeName = temp.name
						}
					}
					this.getCMSListByCategoryId(categoryId)
				}
			},



			/**
			 * @param {Object} item
			 */
			onTagsClicked(item) {
				console.log(item)
				for (let i = 0; i < this.items.length; i++) {
					const temp = this.items[i]
					if (temp.id == item.id) {
						temp.selected = true
					} else {
						temp.selected = false
					}
				}
				this.$forceUpdate()
			},



			async getCMSListByCategoryId(categoryId) {
				this.currentCategoryId = categoryId
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				const temResult = await getInfoList({
					categoryId: categoryId
				})
				if (temResult.code == 200) {
					this.infoList = []
					this.infoList = temResult.data
				}

				const catResult = await getCategories(categoryId)
				if (catResult.code == 200) {
					this.items = []
					this.items = catResult.data
					this.items.forEach(item => {
						item.selected = false
					})
				}
				loading.close()
			},





			ViewDetail(item) {
				this.$router.push({
					path: '/InfoDetail',
					query: {
						cmsId: item.id,
						categoryId: this.currentCategoryId
					}
				});
			}
		}


	}
</script>



<style scoped>
	.cls_form {
		padding-top: 20px;
		border-radius: 3px;
		background-color: white;
	}

	.msg_item {
		display: flex;
		border-radius: 5px;
		background-color: white;
		align-items: flex-end;
		padding-top: 10px;
		padding-bottom: 5px;
		border-bottom: solid 1px #eeeeee;
	}

	.item-img {
		width: 100%;
		height: 120px;
	}


	.item-img-ad {
		width: 100%;
		background-color: white;
		border-radius: 3px;
	}
</style>